import React, { useState, useEffect } from "react";
import { useNavigate } from "../i18n/router";
import { useAuth } from "../contexts/AuthContext";
import { Heart, Loader2 } from "lucide-react";
import { EventMiniCard } from "../components/EventMiniCard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FavoritesPage = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && !user) navigate("/login?redirect=/favorites");
  }, [user, authLoading, navigate]);

  useEffect(() => {
    if (!user) return;
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${BACKEND_URL}/api/favorites`, { credentials: "include" });
        if (res.ok) setEvents(await res.json());
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, [user]);

  const handleUnsave = async (eventId) => {
    await fetch(`${BACKEND_URL}/api/favorites/${eventId}`, { method: "DELETE", credentials: "include" });
    setEvents((prev) => prev.filter((e) => e.id !== eventId));
  };

  if (authLoading || !user) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin" style={{ color: "var(--eunoia-accent)" }} /></div>;
  }

  return (
    <div className="min-h-screen eunoia-space-lg px-4 pb-16" data-testid="favorites-page">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Heart className="h-7 w-7" style={{ color: "var(--eunoia-accent)" }} />
          <h1 className="eunoia-title-large">Сохраненные события</h1>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-16"><Loader2 className="h-8 w-8 animate-spin" style={{ color: "var(--eunoia-accent)" }} /></div>
        ) : events.length === 0 ? (
          <div className="eunoia-surface p-12 text-center">
            <Heart className="h-12 w-12 mx-auto mb-4" style={{ color: "var(--eunoia-whisper)" }} />
            <p className="eunoia-body mb-4">У вас пока нет сохраненных событий</p>
            <button onClick={() => navigate("/events")} className="eunoia-btn-primary">Найти события</button>
          </div>
        ) : (
          <div className="space-y-3">
            {events.map((ev) => (
              <EventMiniCard key={ev.id} event={ev} saved={true} user={user} onToggleSave={handleUnsave} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
